import { render } from "./ErrosBoxComponent.vue?vue&type=template&id=5b3a5fea"
import script from "./ErrosBoxComponent.vue?vue&type=script&lang=js"
export * from "./ErrosBoxComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__